import { useEffect, useRef } from 'react';

const useClickOutside = (callback) => {
  const callbackRef = useRef();
  const innerRef = useRef();

  const clickHandler = (e) => {
    if (innerRef.current && callbackRef.current && !innerRef.current.contains(e.target)) {
      callbackRef.current(e);
    }
  }

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener('click', clickHandler);
    return () => {
      document.removeEventListener('click', clickHandler);
    }
  }, []);

  return innerRef;
}

export default useClickOutside;
